<template>
  <div class="aaaaa">


    <div class="bbbbb">

      <div class="flex center nav" style="justify-content: space-around; margin-bottom: 30px">
        <div :class="status == item.id ? 'navActive' : ''" style="cursor: pointer;" @click="changeNavTab(item, index)"
             v-for="(item, index) in navList" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div>
        <div class="a">
          <el-form label-width="120px" label-height="60px">
            <div v-if="status == 3">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="销售时间" prop="name">
                    <el-date-picker class="select-date" v-model="createTimeArr" placeholder="请输入" type="daterange"
                                    value-format="yyyy-MM-dd" clearable></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="优惠劵状态">
                    <el-select style="width: 100%" v-model="dataStatisticsQuery.status" placeholder="请选择" clearable>
                      <el-option label="全部" value=""></el-option>
                      <el-option label="正常" :value="1"></el-option>
                      <el-option label="作废" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item style="margin-left: -73px">
                    <span style="margin-left: 5px" v-for="(item, index) in butnList" :key="index"><el-button
                      :type="dataStatisticStatus === index ? 'primary' : 'info'"
                      @click="changeStatisticStatus(item, index)">{{ item.name }}</el-button></span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div v-if="status == 1 || status == 2 || status == 0">
              <el-row>
                <!-- <el-col v-if="status == 2" :span="8">
                <el-form-item
                  label="创建时间"
                  prop="createTime"
                >
                  <el-date-picker
                    class="select-date"
                    v-model="queryInfo.condition.createTime"
                    placeholder="请选择"
                    type="date"
                    value-format="yyyy-MM-dd"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col> -->
                <el-col :span="8">
                  <el-form-item :label="status === 0 || status === 1 ? '创建时间' : '领取时间'
                    " prop="name">
                    <el-date-picker class="select-date" v-model="queryInfo.condition.createTimeArr" placeholder="请输入"
                                    type="daterange" value-format="yyyy-MM-dd" clearable></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col v-if="status === 2" :span="8">
                  <el-form-item label="优惠券状态" prop="phone">
                    <el-select style="width: 100%" v-model="queryInfo.condition.useStatus" placeholder="请选择"
                               clearable>
                      <el-option label="未使用" :value="1"></el-option>
                      <el-option label="已使用" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="status === 1 || status === 0" :span="8">
                  <el-form-item label="优惠劵状态">
                    <el-select style="width: 100%" v-model="queryInfo.condition.status" placeholder="请选择" clearable>
                      <el-option label="全部" value=""></el-option>
                      <el-option label="正常" :value="1"></el-option>
                      <el-option label="作废" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="优惠劵类型">
                    <el-select style="width: 100%" v-model="queryInfo.condition.couponType" placeholder="请选择"
                               clearable>
                      <el-option label="全部" value=""></el-option>
                      <el-option label="代金券" :value="1"></el-option>
                      <el-option label="折扣券" :value="2"></el-option>
                      <el-option label="满减券" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="优惠劵名称" prop="phone">
                    <el-input v-model="queryInfo.condition.couponName" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="status == 1" :span="8">
                  <el-form-item label="活动名称" prop="activeName">
                    <el-input v-model="queryInfo.condition.activeName" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="status == 1" :span="8">
                  <el-form-item label="创建人" prop="creator">
                    <el-input v-model="queryInfo.condition.creator" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="status === 2" :span="8">
                  <el-form-item label="用户昵称" prop="openTime">
                    <el-input v-model="queryInfo.condition.memberName" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="status === 2">
                  <el-form-item label="用户手机号" prop="openTime">
                    <el-input v-model="queryInfo.condition.uPhone" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="status === 2">
                  <el-form-item label="发放形式" prop="openTime">
                    <el-select style="width: 100%" v-model="queryInfo.condition.getType" placeholder="请选择" clearable>
                      <el-option label="手动领取" :value="1"></el-option>
                      <el-option label="自动领取" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="status === 2">
                  <el-form-item label="订单编号" prop="orderNumber">
                    <el-input v-model="queryInfo.condition.orderNumber" placeholder="请输入" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </div>

        <!-- 头部部分 -->
        <div ref="search_d">
          <el-row type="flex" class="row-bg" justify="space-between">
            <!-- <el-row v-if="status == 2 || status == 3">
            <el-button style="display: none" type="primary">111</el-button>
          </el-row> -->
            <el-row v-if="status == 0">
<!--              <el-button type="primary" @click="toggleSelection()">{{-->
<!--                  selectBut-->
<!--                }}-->
<!--              </el-button>-->
              <el-button type="primary" @click="newBtn">新增优惠劵</el-button>
<!--              <el-button v-if="status == 0" type="primary" @click="giveCoupons">批量发劵</el-button>-->
<!--              <el-button type="primary" @click="delAllCoupon()">批量删除</el-button>-->
            </el-row>
            <el-row v-if="status == 1">
              <el-button type="primary" @click="newsiftBtn">活动发券</el-button>
            </el-row>
            <div></div>
            <el-row v-if="
              status == 0 ||
              status == 1 ||
              status == 2 ||
              (status == 3 && dataStatisticStatus == -1)
            ">
              <el-button @click="resetThree" class="pull-right" icon="el-icon-refresh-left">重置</el-button>
              <el-button type="primary" class="pull-right" @click="search" icon="el-icon-search">搜索</el-button>
            </el-row>
          </el-row>
        </div>

        <!-- 表格部分 -->
        <div v-if="status == 0">
          <el-table @selection-change="handleSelectionChange" v-loading="loading" type border ref="table"
                    :data="tableData" :key="tablekey" tooltip-effect="dark" style="width: 100%" :height="height">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="优惠券名称" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.couponName }}</template>
            </el-table-column>
            <el-table-column label="优惠券类型" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  getTypeName(scope.row.couponType)
                }}
              </template>
            </el-table-column>
            <el-table-column label="优惠券状态" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.useStatus == 2 ? '作废' : '正常' }}</template>
            </el-table-column>
            <el-table-column label="代金券面值" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.faceAmount }}</template>
            </el-table-column>
            <el-table-column label="折扣" align="center" show-overflow-tooltip width="100">
              <template slot-scope="scope">{{ scope.row.discount }}</template>
            </el-table-column>
            <el-table-column label="满多少" align="center" show-overflow-tooltip width="100">
              <template slot-scope="scope">{{ scope.row.fullAmount }}</template>
            </el-table-column>
            <el-table-column label="减多少" align="center" show-overflow-tooltip width="100">
              <template slot-scope="scope">{{ scope.row.reduceAmount }}</template>
            </el-table-column>
            <el-table-column label="是否有门槛" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  getIsLimit(scope.row.isLimit)
                }}
              </template>
            </el-table-column>
            <el-table-column label="满消费/元" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  scope.row.customeAmount
                }}
              </template>
            </el-table-column>
            <el-table-column label="优惠券有效期类型" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  getLimitTypeName(scope.row.limitType)
                }}
              </template>
            </el-table-column>
            <el-table-column label="有效期开始时间" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  scope.row.limitStartTime
                }}
              </template>
            </el-table-column>
            <el-table-column label="有效期结束时间" align="center" prop="limitEndTime" show-overflow-tooltip
                             width="180">
              <template slot-scope="scope">{{ showendtime(scope.row) }}</template>
            </el-table-column>
            <el-table-column label="适用范围" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  getUseAreaName(scope.row.useArea)
                }}
              </template>
            </el-table-column>
            <el-table-column label="适用用户" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  getUserType(scope.row.userType)
                }}
              </template>
            </el-table-column>
            <el-table-column label="与其他优惠劵同享" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  scope.row.isShare != 1 ? "同享" : "不同享"
                }}
              </template>
            </el-table-column>
            <el-table-column label="与优惠活动同享" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{
                  scope.row.activityShare != 1 ? "同享" : "不同享"
                }}
              </template>
            </el-table-column>
            <el-table-column label="发放数量" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.num }}</template>
            </el-table-column>
            <el-table-column label="剩余数量" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.surplusNum }}</template>
            </el-table-column>
            <el-table-column label="每人限领" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.limitNum }}</template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.createTime }}</template>
            </el-table-column>
            <el-table-column label="修改时间" align="center" show-overflow-tooltip width="180">
              <template slot-scope="scope">{{ scope.row.updateTime }}</template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
              <template slot-scope="scope">
                <div v-if="status == 0" class="button-container"
                     style="display: flex;align-items: center;justify-content: center;">
                  <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button>
                  <el-button type="text" @click="giveUnitCoupon(scope.row)" size="small"
                             style="padding: 0;margin: 0;">发劵
                  </el-button>
                  <el-popconfirm title="确定删除吗？" @confirm="handleDelte(scope.row.id)">
                    <el-button slot="reference" style="color: red;" type="text">删除</el-button>
                  </el-popconfirm>
                </div>
                <div v-if="status == 1" class="button-container"
                     style="display: flex;align-items: center;justify-content: center;">
                  <el-button type="text" @click="diftdetail(scope.row)" size="small">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]"
                           :page-size="queryInfo.pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
        <div v-else-if="status == 1">
          <el-table v-loading="loading" @selection-change="handleSelectionChange" type border ref="table"
                    :data="tableData" :key="tablekey" tooltip-effect="dark" style="width: 100%" :height="height">
            <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
            <el-table-column label="活动名称" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.activeName }}</template>
            </el-table-column>
            <el-table-column label="优惠券名称" align="center" width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.couponName }}</template>
            </el-table-column>
            <el-table-column label="优惠券类型" align="center" width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{
                  getTypeName(scope.row.couponType)
                }}
              </template>
            </el-table-column>
            <el-table-column label="优惠券状态" align="center" width="180" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.useStatus == 2 ? '作废' : '正常' }}</template>
            </el-table-column>
            <el-table-column label="已领取数" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{
                  scope.row.customeAmount
                }}
              </template>
            </el-table-column>
            <el-table-column label="已使用数" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{
                  scope.row.customeAmount
                }}
              </template>
            </el-table-column>
            <el-table-column label="发券开始时间" width="200" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{
                  scope.row.startTime
                }}
              </template>
            </el-table-column>
            <el-table-column label="发券结束时间" width="200" align="center" prop="limitEndTime" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.endTime }}</template>
            </el-table-column>
            <el-table-column label="活动状态" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{
                  getUseAreaName(scope.row.useArea)
                }}
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="150" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.createTime }}</template>
            </el-table-column>
            <el-table-column label="创建人" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.creator }}</template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
              <template slot-scope="scope">
                <div class="button-container" style="display: flex;align-items: center;justify-content: center;">
                  <el-button type="text" @click="diftdetail(scope.row)" size="small">详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]"
                           :page-size="queryInfo.pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
        <div v-else-if="status == 2">
          <give-coupon-records :table-data="recordTable" :total="recordTotal"
                               :query-info="queryInfo"></give-coupon-records>
        </div>

        <div>
          <el-dialog title="发劵" center :visible="unitDialogVisible" @close="setUnitDialogVisible" width="50%">
            <hr/>
            <el-form :model="giveCouponForm" :rules="giveCouponRules" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm" style="height: 300px" size="mini">
              <el-col :span="24">
                <el-form-item label="用户手机号" prop="phones">
                  <!--                  <el-select class="active-input-give" v-model="giveCouponForm.phones" multiple filterable>-->
                  <!--                    <el-option @change="changePhone" v-if="item.phone && item.phone != '' && item.phone != null" v-for="item in memberList"-->
                  <!--                      :key="item.id" :label="item.phone" :value="item.phone">-->
                  <!--                    </el-option>-->
                  <!--                  </el-select>-->

                  <!--                  multiple-->

                  <el-select class="active-input-give" multiple @change="changePhone" v-model="giveCouponForm.phones"
                             filterable>
                    <el-option
                      v-for="item in memberList" v-if="item.phone && item.phone != '' && item.phone != null"
                      :key="item.id" :label="item.phone" :value="item.phone">
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="发放数量：" prop="count">
                  <el-input class="active-input-give" v-model="giveCouponForm.count" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <span slot="footer">
              <el-button size="small" @click="unitDialogVisible = false">取消</el-button>
              <el-button size="small" type="primary" @click="giveCouponFormSave">确定</el-button>
            </span>
          </el-dialog>
          <el-dialog title="批量发劵" center :visible="dialogVisible" @close="setdialogVisible" width="50%">
            <el-button v-if="!importVisible" type="primary" @click="importMember">导入用户</el-button>
            <el-button v-else type="primary" @click="selectMember">选择用户</el-button>
            <hr/>
            <el-form :model="giveCouponForm" :rules="giveCouponRules" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm" style="height: 300px" size="mini">
              <el-col v-show="!importVisible" :span="24">
                <el-form-item label="用户手机号" prop="phones">
                  <el-select class="active-input-give" v-model="giveCouponForm.phones" multiple filterable>
                    <el-option v-if="item.phone && item.phone != '' && item.phone != null" v-for="item in memberList"
                               :key="item.id" :label="item.phone" :value="item.phone">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 上传excel         -->
              <el-col :span="24" v-show="importVisible">
                <a style="color: #1e98d7; margin-left: 20px" href="https://stjnapi.duochicai.com/resources/upload/dcc/优惠券发放模版.xlsx">点击下载导入模板</a>
              </el-col>
              <el-col :span="24" style="margin-top: 10px" v-show="importVisible">
                <el-form-item label="导入文件：" prop="file">
                  <el-upload class="upload-demo" action="" :http-request="uploadExcel" :on-preview="handlePreview"
                             :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1"
                             :on-exceed="handleExceed" :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
                  </el-upload>
                </el-form-item>
              </el-col>

              <el-col v-show="importVisible" :span="24">
                <el-form-item label="导入手机号" prop="phones">
                  <el-select disabled class="active-input-give" v-model="giveCouponForm.phones" multiple filterable>
                    <el-option v-if="item.phone && item.phone != '' && item.phone != null" v-for="item in memberList"
                               :key="item.id" :label="item.phone" :value="item.phone">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="发放数量：" prop="count">
                  <el-input class="active-input-give" v-model="giveCouponForm.count" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <span slot="footer">
              <el-button size="small" @click="dialogVisible = false">取消</el-button>
              <el-button size="small" type="primary" @click="giveCouponFormSave">确定</el-button>
            </span>
          </el-dialog>
        </div>

        <div v-if="status === 3">
          <data-statistics :data="statistics" :map="statisticsMap"></data-statistics>
        </div>
        <el-dialog :title="labelType == 'add' ? '新增' : '编辑'" :visible.sync="showDialog" width="800px">
          <el-form ref="form" :model="form" :rules="rules" label-width="135px">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <p class="title-text">优惠劵信息</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="top">
              <el-col :span="24">
                <el-form-item label="优惠券名称：" prop="couponName">
                  <el-input class="col-text" v-model="form.couponName" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="优惠券类型：" prop="couponType">
                  <el-radio v-model="form.couponType" :label="1">代金劵</el-radio>
                  <el-radio v-model="form.couponType" :label="2">折扣劵</el-radio>
                  <el-radio v-model="form.couponType" :label="3">满减劵</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item v-show="form.couponType === 2" label="折扣：" prop="siteName">
                  <el-input class="active-input" type="number" :step="0.1" v-model="form.discount"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item v-show="form.couponType === 1" label="优惠券面额：" prop="faceAmount">
                  <el-input class="col-text" v-model="form.faceAmount" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item v-show="form.couponType === 3" label="满多少：" prop="fullAmount">
                  <el-input type="number" class="active-input" :min="0" :step="0.01" v-model="form.fullAmount"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item v-show="form.couponType === 3" label="减多少：" prop="reduceAmount">
                  <el-input type="number" class="active-input" :min="0" :step="0.01" v-model="form.reduceAmount"
                            placeholder="请输入"/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item v-show="form.couponType === 2" label="是否有门槛：" prop="isLimit">
                  <el-radio v-model="form.isLimit" :label="1">有</el-radio>
                  <el-radio v-model="form.isLimit" :label="2">无</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item v-show="form.isLimit === 1" label="消费最低：" prop="customeAmount">
                  <el-input type="number" :min="0" class="col-text" v-model="form.customeAmount"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="优惠券有效期：" prop="limitType">
                  <el-radio v-model="form.limitType" :label="1">固定时间</el-radio>
                  <el-radio v-model="form.limitType" :label="2">领取时间</el-radio>
                  <el-radio v-model="form.limitType" :label="3">长期有效</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-show="form.limitType === 2" :span="24">
                <el-form-item label="领取后失效时间：" prop="receive">
                  <el-select class="active-input" v-model="form.receive" placeholder="请输入">
                    <el-option :value="1" label="一周"/>
                    <el-option :value="2" label="一个月"/>
                    <el-option :value="3" label="三个月"/>
                    <el-option :value="4" label="半年"/>
                    <el-option :value="5" label="一年"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-show="form.limitType === 1" :span="24">
                <el-form-item label="" prop="daterange">
                  <el-date-picker v-model="daterange" type="daterange" range-separator="-" start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row class="top">
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <p class="title-text">优惠劵设置</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="top">
              <el-col :span="24">
                <el-form-item label="适用范围：" prop="useArea">
                  <el-radio v-model="form.useArea" :label="1">全场通用</el-radio>
                  <el-radio v-model="form.useArea" :label="2">指定商品组</el-radio>
                  <el-radio v-model="form.useArea" :label="3">指定商品</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-show="form.useArea === 3" :span="24">
                <el-form-item label="选择商品：" prop="productCodes">
                  <el-select class="c-type" v-model="form.productCodes" multiple filterable>
                    <el-option v-for="item in productList" :key="item.productCode" :label="item.productName"
                               :value="item.productCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-show="form.useArea === 2" :span="24">
                <el-form-item label="选择商品组：" prop="categoryCodes">
                  <el-select class="c-type" v-model="form.categoryCodes" multiple filterable>
                    <el-option v-for="item in productCategoryList" :key="item.categoryCode" :label="item.categoryName"
                               :value="item.categoryCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="领取用户：" prop="userType">
                  <el-radio v-model="form.userType" :label="1">全场用户</el-radio>
                  <el-radio v-model="form.userType" :label="2">指定用户</el-radio>
                  <el-radio v-model="form.userType" :label="3">新用户</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-show="form.userType === 2" :span="24">
                <el-form-item label="选择用户：" prop="userCodes">
                  <el-select class="c-type" v-model="form.userCodes" multiple filterable>
                    <el-option v-for="item in memberList" :key="item.memberCode" :label="item.memberName"
                               :value="item.memberCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="优惠劵同享：" prop="isShare">
                  <el-radio v-model="form.isShare" :label="1">不允许与其他优惠券同享</el-radio>
                  <el-radio v-model="form.isShare" :label="2">允许与其他同享
                  </el-radio>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="优惠活动同享：" prop="isShare">
                  <el-radio v-model="form.activityShare" :label="1">不允许与活动专区同享
                  </el-radio>
                  <el-radio v-model="form.activityShare" :label="2">允许与其他同享</el-radio>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="发放总量：" prop="num">
                  <el-input :disabled="disabled1" type="number" :min="0" :max="999999999" class="col-text"
                            v-model="form.num" placeholder="请输入">
                    <template slot="append">张</template>
                  </el-input>
                  <el-checkbox v-model="num" :label="9999999" @change="nums()" label="不限"/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="每人限领：" prop="limitNum">
                  <el-input :disabled="disabled2" type="number" :min="0" :max="999999999" class="col-text"
                            v-model="form.limitNum" placeholder="请输入">
                    <template slot="append">张</template>
                  </el-input>
                  <el-checkbox v-model="limitNum" :label="9999999" @change="limitNums()" label="不限"/>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="使用说明：" prop="siteName">
                  <el-input @input="timeEffectInput" maxlength="200" resize="none" show-word-limit class="col-text"
                            type="textarea" v-model="form.remark" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer">
            <el-button size="small" @click="showDialog = false">取消</el-button>
            <el-button size="small" type="primary" @click="handleSave">确定</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="labelType == 'add' ? '新增精准优惠券' : '精准优惠券信息'" :visible.sync="siftDialogVisible"
                   width="800px">
          <el-form ref="form" :model="form" :rules="siftrules" label-width="135px">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  <p class="title-text">精准优惠劵信息</p>
                </div>
              </el-col>
            </el-row>
            <el-row class="top">
              <el-col :span="24">
                <el-form-item label="活动名称" prop="activeName">
                  <el-input class="col-text" v-model="form.activeName" placeholder="请输入"
                            :readonly="labelType == 'view'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="发券时间" prop="siftdaterange">
                  <el-date-picker v-model="siftdaterange" type="datetimerange" range-separator="-" unlink-panels
                                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['', '23:59:59']"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期" :disabled="labelType == 'view'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="周期类型" prop="taskType">
                  <el-radio-group v-model="form.taskType" :disabled="labelType == 'view'" @change="clearday">
                    <!-- <el-radio :label="-1">按时间</el-radio> -->
                    <el-radio :label="0">周</el-radio>
                    <el-radio :label="1">月</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="form.taskType == 0 || form.taskType == 1" style="padding-left: 135px;">
                <el-checkbox :indeterminate="siftisIndeterminate" v-model="checkAll"
                             @change="handleCheckAllChange">全选
                </el-checkbox>
                <el-checkbox-group v-if="form.taskType == 0" v-model="form.day" @change="handleDayChange">
                  <el-checkbox v-for="item in daylist1list" :label="item" :key="item" style="margin: 8px 25px 0px 0;">{{
                      get1day(item)
                    }}
                  </el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-else-if="form.taskType == 1" v-model="form.day" @change="handleDayChange">
                  <el-checkbox v-for="item in daylist2list" :label="item" :key="item" style="margin: 8px 25px 0px 0;">{{
                      item
                    }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
            <el-row class="top">
              <el-col :span="24">
                <el-form-item label="发放场景" prop="scanner">
                  <el-radio-group v-model="form.scanner" :disabled="labelType == 'view'" @change="scannerChange">
                    <el-radio :label="0">无条件发劵</el-radio>
                    <el-radio :label="1">登录发劵</el-radio>
                    <el-radio :label="2">消费发劵</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="form.scanner == 2" :span="24">
                <el-form-item label="购买商品金额" prop="fullAmountRule">
                  <el-input class="col-text" v-model.number="form.fullAmountRule" placeholder="请输入"
                            :readonly="labelType == 'view'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="top">
              <el-col :span="24">
                <el-form-item label="选择优惠券" prop="couponCode">
                  <el-select class="c-type" v-model="form.couponCode" filterable :disabled="labelType == 'view'"
                             no-data-text="请选择发券时间">
                    <el-option v-for="item in couponList2" :key="item.couponCode" :label="item.couponName"
                               :value="item.couponCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="发券范围" prop="giveCouponRage">
                  <el-radio v-model="form.giveCouponRage" :label="0" :disabled="labelType == 'view'">全部用户</el-radio>
                  <el-radio v-model="form.giveCouponRage" :label="1" :disabled="labelType == 'view'">指定用户</el-radio>
                  <el-radio v-model="form.giveCouponRage" :label="2" :disabled="labelType == 'view'">新用户</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-show="form.giveCouponRage == 1" :span="24">
                <el-form-item label="选择用户" prop="userCodes">
                  <el-select class="c-type" v-model="form.userCodes" multiple filterable>
                    <el-option v-for="item in memberList" :key="item.memberCode" :label="item.memberName"
                               :value="item.memberCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="领券设置" prop="claimSetting">
                  <el-radio v-model="form.claimSetting" :label="0" :disabled="labelType == 'view'">自动领取</el-radio>
                  <el-radio v-model="form.claimSetting" :label="1" :disabled="labelType == 'view'">主动领取</el-radio>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="每天限领" prop="numEveryDay">
                  <el-input type="number" :min="0" :max="999999999" class="col-text" v-model="form.numEveryDay"
                            placeholder="请输入">
                    <template slot="append">张</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer">
            <el-button size="small" @click="siftDialogVisible = false">取消</el-button>
            <el-button size="small" type="primary" @click="handlesiftSave">确定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import GiveCouponRecords from './GiveCouponRecords.vue'
import DataStatistics from './DataStatistics.vue'

const daylist1 = ['1', '2', '3', '4', '5', '6', '7']
const daylist2 = [
  '1', '2', '3', '4', '5', '6', '7',
  '8', '9', '10', '11', '12', '13', '14',
  '15', '16', '17', '18', '19', '20', '21',
  '22', '23', '24', '25', '26', '27', '28',
  '29', '30', '31'
]
export default {
  components: {
    GiveCouponRecords,
    DataStatistics
  },
  data() {
    return {
      dataStatisticStatus: 0,
      butnList: [
        {name: '今日', value: 0},
        {name: '本周', value: 1},
        {name: '本月', value: 2},
        {name: '本年', value: 3}
      ],
      navList: [
        {name: '优惠劵管理',id:0},
        // {name: '精准发劵'},
        {name: '发放记录',id:2},
        {name: '数据统计',id:3}
      ],

      unitDialogVisible: false,
      // 上传文件列表
      fileList: [],
      uploadUrl: '',
      // 导入文件和选择用户开关
      importVisible: false,
      selectBut: '全部选择',
      selectFlag: true,
      giveCouponForm: {couponCodes: [],phones:""},
      giveCouponRules: {
        file: [{required: true, message: '请选择用户', trigger: 'blur'}],
        phones: [{required: true, message: '请选择用户', trigger: 'blur'}],
        count: [{required: true, message: '请输入数量', trigger: 'blur'}]
      },
      status: 0,
      // 商品级
      productCategoryList: [],
      // 商品数组
      productList: [],
      // 用户数组
      memberList: [],
      // 手机号数组
      phoneList: [],
      // 发放总量不限变量
      num: 0,
      // 限购不限变量
      limitNum: 0,
      dialogVisible: false,
      daterange: [],
      saveFlag: 0,
      tempNumber: 0,
      tempLimitNum: 0,
      labelType: 'add',
      rules: {
        couponName: [
          {required: true, message: '请输入优惠券名称', trigger: 'blur'}
        ],
        couponType: [
          {
            required: true,
            message: '请选择优惠券类型',
            trigger: ['blur', 'change']
          }
        ],
        faceAmount: [
          {required: true, message: '请输入代金券面值', trigger: 'blur'}
        ],
        discount: [{required: true, message: '请输入折扣', trigger: 'blur'}],
        fullAmount: [
          {required: true, message: '请输入满值金额', trigger: 'blur'}
        ],
        reduceAmount: [
          {required: true, message: '请输入减值金额', trigger: 'blur'}
        ],
        isLimit: [
          {
            required: true,
            message: '请选择是否有门槛',
            trigger: ['blur', 'change']
          }
        ],
        customeAmount: [
          {required: true, message: '请输入消费门槛额', trigger: 'blur'}
        ],
        limitType: [
          {
            required: true,
            message: '请选择优惠券有效期',
            trigger: ['blur', 'change']
          }
        ],
        limitStartTime: [
          {required: true, message: '请输入有效期开始时间', trigger: 'blur'}
        ],
        limitEndTime: [
          {required: true, message: '请输入有效期结束时间', trigger: 'blur'}
        ],
        useArea: [
          {required: true, message: '请选择适用范围', trigger: 'blur'}
        ],
        userType: [
          {required: true, message: '请选择适用用户', trigger: 'change'}
        ],
        activityShare: [
          {
            required: true,
            message: '请选择活动优惠同享',
            trigger: ['blur', 'change']
          }
        ],
        isShare: [
          {
            required: true,
            message: '请选择优惠同享',
            trigger: ['blur', 'change']
          }
        ],
        num: [{required: true, message: '请输入发放数量', trigger: 'change'}],
        limitNum: [
          {required: true, message: '请输入每人限领', trigger: 'blur'}
        ],
        receive: [
          {required: true, message: '请选择领取后多久失效', trigger: 'blur'}
        ],
        productCodes: [
          {required: true, message: '请选择商品', trigger: 'blur'}
        ],
        categoryCodes: [
          {required: true, message: '请选择商品组', trigger: 'blur'}
        ],
        userCodes: [{required: true, message: '请选择用户', trigger: 'blur'}]
      },
      siftrules: {
        couponName: [
          {required: true, message: '请输入优惠券名称', trigger: 'blur'},
          {
            min: 3,
            max: 30,
            message: '密码长度在 3 到 30 个字符',
            trigger: 'blur'
          }
        ],
        couponType: [
          {
            required: true,
            message: '请选择优惠券类型',
            trigger: ['blur', 'change']
          }
        ],
        faceAmount: [
          {required: true, message: '请输入代金券面值', trigger: 'blur'}
        ],
        discount: [{required: true, message: '请输入折扣', trigger: 'blur'}],
        fullAmount: [
          {required: true, message: '请输入满值金额', trigger: 'blur'}
        ],
        reduceAmount: [
          {required: true, message: '请输入减值金额', trigger: 'blur'}
        ],
        isLimit: [
          {
            required: true,
            message: '请选择是否有门槛',
            trigger: ['blur', 'change']
          }
        ],
        customeAmount: [
          {required: true, message: '请输入消费门槛额', trigger: 'blur'}
        ],
        limitType: [
          {
            required: true,
            message: '请选择优惠券有效期',
            trigger: ['blur', 'change']
          }
        ],
        limitStartTime: [
          {required: true, message: '请输入有效期开始时间', trigger: 'blur'}
        ],
        limitEndTime: [
          {required: true, message: '请输入有效期结束时间', trigger: 'blur'}
        ],
        useArea: [
          {required: true, message: '请选择适用范围', trigger: 'blur'}
        ],
        userType: [
          {required: true, message: '请选择适用用户', trigger: 'blur'}
        ],
        activityShare: [
          {
            required: true,
            message: '请选择活动优惠同享',
            trigger: ['blur', 'change']
          }
        ],
        isShare: [
          {
            required: true,
            message: '请选择优惠同享',
            trigger: ['blur', 'change']
          }
        ],
        num: [{required: true, message: '请输入发放数量', trigger: 'change'}],
        limitNum: [
          {required: true, message: '请输入每人限领', trigger: 'change'}
        ],
        receive: [
          {required: true, message: '请选择领取后多久失效', trigger: 'blur'}
        ],
        productCodes: [
          {required: true, message: '请选择商品', trigger: 'blur'}
        ],
        categoryCodes: [
          {required: true, message: '请选择商品组', trigger: 'blur'}
        ],
        userCodes: [{required: true, message: '请选择用户', trigger: 'blur'}]
      },
      total: 0,
      queryInfo: {
        pageSize: 100,
        currPage: 1,
        condition: {createTimeArr: null, createTime: ''}
      },
      form: {
        limitNum: 0,
        num: 0,
        isShare: 2,
        activityShare: 2,
        couponCode: '',
        fullAmountRule: 0,
        day: []
      },
      showDialog: false,
      rows: [],
      tableData: [],
      recordTable: [],
      recordTotal: 0,
      height: window.innerHeight - 290, // 表格高度
      headerHeight: 0,
      statistics: {},
      createTimeArr: [],
      statisticsMap: {},
      dataStatisticsQuery: {type: 0},
      defaultProps: {
        children: 'childList',
        label: 'categoryName',
        value: 'categoryCode'
      },
      // 精选发券
      siftDialogVisible: false,
      siftdaterange: [],
      couponList: [],
      couponList2: [],
      siftisIndeterminate: false,
      checkAll: false,
      daylist1list: daylist1,
      daylist2list: daylist2,
      tablekey: 'coupon1',
      disabled1: false,
      disabled2: false,
      loading: false
    }
  },

  created() {
    this.getList()
    this.getStatistics()
    this.getStatisticsEchars()
  },
  watch: {
    siftdaterange(val) {
      this.getQueryTaskFitList()
    }
  },

  mounted() {
    this.getUserList()
    this.getProductList()
    this.getProductCategory()
    this.getCouponList()
    // this.get;
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 获得数据
    async getStatisticsEchars() {
      await this.$http
        .post('/coupon/getStatisticsEchars', this.dataStatisticsQuery)
        .then((response) => {
          if (response.data.code == 200) {
            this.statisticsMap = response.data.data
          }
        })
    },
    // 获得数据
    async getStatistics() {
      await this.$http
        .post('/coupon/getStatistics', this.dataStatisticsQuery)
        .then((response) => {
          if (response.data.code == 200) {
            console.log(response.data.data, 1234567)
            this.statistics = response.data.data
          }
        })
    },
    get1day(val) {
      switch (val) {
        case '1':
          return '周一'
        case '2':
          return '周二'
        case '3':
          return '周三'
        case '4':
          return '周四'
        case '5':
          return '周五'
        case '6':
          return '周六'
        case '7':
          return '周日'

        default:
          return ''
      }
    },

    changePhone(val) {
      console.log(val, 1061)
    },


    search() {
      this.queryInfo.currPage = 1
      if (this.queryInfo.condition.createTimeArr != null) {
        console.log('-------=====--')
        this.queryInfo.condition.createTimeStart = this.queryInfo.condition.createTimeArr[0]
        this.queryInfo.condition.createTimeEnd = this.queryInfo.condition.createTimeArr[1]
      } else {
        this.queryInfo.condition.createTimeStart = null
        this.queryInfo.condition.createTimeEnd = null
      }
      if (this.status == 0 || this.status == 1) {
        console.log('---------', this.queryInfo)
        this.getList()
      }
      if (this.status == 2) {
        this.getGiveCouponRecords()
      }
      if (this.status == 3) {
        if (this.createTimeArr != null) {
          if (this.createTimeArr.length != 0) {
            this.dataStatisticsQuery.updateTimeStart = this.createTimeArr[0]
            this.dataStatisticsQuery.updateTimeEnd = this.createTimeArr[1]
          }
        }
        console.log(this.dataStatisticsQuery.type, '----lll')
        console.log(this.dataStatisticsQuery.updateTimeStart, '----lll')
        if (
          (this.dataStatisticsQuery.updateTimeStart != null ||
            this.dataStatisticsQuery.updateTimeEnd != null) &&
          this.dataStatisticsQuery.type != null
        ) {
          this.$message({
            message: '周期按钮和销售时间搜索不可同时查询,或者不能无条件查询',
            type: 'warning'
          })
        }
        if (
          this.dataStatisticsQuery.updateTimeStart == null &&
          this.dataStatisticsQuery.updateTimeEnd == null &&
          this.dataStatisticsQuery.type == null
        ) {
          this.$message({
            message: '周期按钮和销售时间不可同时搜索，不可无条件查询',
            type: 'warning'
          })
        }
        this.getStatistics()
        this.getStatisticsEchars()
      }
    },
    // 发劵记录数据
    async getGiveCouponRecords() {
      var that = this
      const data = {
        currPage: this.queryInfo.currPage,
        pageSize: this.queryInfo.pageSize,
        condition: {...this.queryInfo.condition}
      }
      if (this.queryInfo.condition.createTimeArr != null) {
        data.condition.startDate = this.queryInfo.condition.createTimeArr[0]
        data.condition.endDate = this.queryInfo.condition.createTimeArr[1]
      }

      data.condition.createTimeStart = null
      data.condition.createTimeEnd = null
      await that.$http
        .post('/memberCoupon/list', data)
        .then(function (response) {
          if (response.data.code == 200) {
            that.recordTotal = response.data.data.count
            that.queryInfo.currPage = response.data.data.currPage
            that.recordTable = response.data.data.data
          }
        })
    },
    changeStatisticStatus(item, index) {
      if (this.dataStatisticStatus == index) {
        this.dataStatisticStatus = -1
        this.dataStatisticsQuery.type = null
      } else {
        this.dataStatisticStatus = index
        this.dataStatisticsQuery.type = item.value
        this.getStatistics()
        this.getStatisticsEchars()
      }
    },
    changeNavTab(item, index) {
      const _random = Math.random()
      this.tablekey = `${_random}`
      this.status = item.id
      if (this.status === 2) {
        this.getGiveCouponRecords()
      }
      this.search()
    },
    showendtime(row) {
      if (row.limitEndTime) {
        return row.limitEndTime
      } else {
        switch (row.receive) {
          case 1:
            return `领取后一周`
          case 2:
            return `领取后一个月`
          case 3:
            return `领取后三个月`
          case 4:
            return `领取后半年`
          case 5:
            return `领取后一年`

          default:
            return ''
        }
      }
    },
    getUserType(val) {
      if (val === 1) {
        return '全部用户'
      }
      if (val === 2) {
        return '指定用户'
      }
      if (val === 3) {
        return '新用户'
      }
    },
    getUseAreaName(val) {
      if (val === 1) {
        return '全场通用'
      }
      if (val === 2) {
        return '指定商品组'
      }
      if (val === 3) {
        return '指定商品'
      }
    },
    getLimitTypeName(val) {
      if (val === 1) {
        return '固定时间'
      }
      if (val === 2) {
        return '领取时间'
      }
      if (val === 3) {
        return '长期有效'
      }
    },
    getTypeName(val) {
      if (val === 1) {
        return '代金券'
      }
      if (val === 2) {
        return '折扣券'
      }
      if (val === 3) {
        return '满减券'
      }
    },
    giveUnitCoupon(row) {
      this.saveFlag = 1
      this.unitDialogVisible = true
      this.giveCouponForm.couponCodes.push(row.couponCode)
    },
    setUnitDialogVisible() {
      this.unitDialogVisible = false
    },
    async uploadExcel(event) {
      this.hUploading = true
      setTimeout(() => {
        if (this.hUploading) {
          this.hUploading = false
        }
      }, 3000)
      const file = event.file
      // 使用 FormData 包装文件
      const formData = new FormData()
      formData.append('file', file)
      const res = await this.$http.post('/importExcel/importMember', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // 设置正确的Content-Type
        }
      })
      if (res.data.code === 200) {
        var readMemberList = res.data.data.data
        for (let i = 0; i < readMemberList.length; i++) {
          this.giveCouponForm.phones.push(readMemberList[i].phone)
        }
      } else {
        this.$notify.info({
          title: '提示',
          message: res.data.message,
          showClose: true
        })
      }
      this.hUploading = false
    },
    // 文件上传组件
    handleRemove(file, fileList) {
      this.giveCouponForm.phones = []
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 打开导入用户的表单
    importMember() {
      this.importVisible = true
    },
    selectMember() {
      this.importVisible = false
    },
    // 保存发劵信息
    giveCouponFormSave() {
      if (this.saveFlag === 1) {
        this.saveFlag = 0
        var that = this
        if (that.giveCouponForm.couponCodes.length === 0) {
          this.$message({
            message: '优惠劵未选择',
            type: 'warning'
          })
        } else {
          that.$http
            .post('/coupon/giveCoupons', that.giveCouponForm)
            .then(function (response) {
              if (response.data.code == 200) {
                that.$notify.success({
                  title: '提示',
                  message: '保存成功',
                  showClose: true
                })
                that.dialogVisible = false
                that.unitDialogVisible = false
                // that.getList();
                that.reset()
                this.saveFlag = 0
              } else {
                that.$notify.info({
                  title: '提示',
                  message: response.data.message,
                  showClose: true
                })
              }
            })
            .catch(function (error) {
              that.$notify.error({
                title: '提示',
                message: response.data.message,
                showClose: true
              })
            })
        }
      }
    },

    toggleSelection() {
      var rows = this.tableData
      // this.selectFlag = -this.selectFlag;
      if (this.selectBut === '全部取消') {
        this.selectBut = '全部选择'
      } else {
        this.selectBut = '全部取消'
      }
      if (rows) {
        rows.forEach((row) => {
          this.$refs.table.toggleRowSelection(row)
          this.giveCouponForm.couponCodes.push(row.couponCode)
        })
      } else {
        this.$refs.table.clearSelection()
      }
    },
    delAllCoupon() {
      console.log(this.giveCouponForm.couponCodes, '====')
      let that = this
      if (this.giveCouponForm.couponCodes.length === 0) {
        this.$message({
          message: '优惠劵未选择',
          type: 'warning'
        })
      } else {
        this.$confirm('此操作将永久删除优惠卷, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$http.post('/coupon/deleteBatch', {
            deleteList: this.giveCouponForm.couponCodes
          }).then(res => {
            if (res.data.code == 200) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.getList()
            } else {
              that.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        })
      }
    },
    handleSelectionChange(val) {
      var couponCodes = []
      val.forEach((v) => {
        couponCodes.push(v.couponCode)
      })
      this.giveCouponForm.couponCodes = couponCodes
      console.log(this.giveCouponForm.couponCodes)
    },
    setdialogVisible() {
      this.dialogVisible = false
      this.saveFlag = 0
    },
    // 批量发劵
    giveCoupons() {

      if (this.giveCouponForm.couponCodes.length === 0) {
        return this.$message.error("请先选择要发放的优惠券")
      }

      this.giveCouponForm.phones = ""
      this.fileList = []
      this.dialogVisible = true
      this.saveFlag = 1
    },
    nums() {
      if (this.form.num !== 999999999) {
        this.tempNumber = this.form.num
      }
      if (this.tempNumber === undefined) {
        this.tempNumber = 0
      }
      if (this.num) {
        this.form.num = 999999999
        this.disabled1 = true
      } else {
        this.disabled1 = false
      }
    },
    limitNums() {
      if (this.form.num !== 999999999) {
        this.tempLimitNum = this.form.num
      }
      if (this.tempLimitNum === undefined) {
        this.tempLimitNum = 0
      }
      if (this.limitNum) {
        this.form.limitNum = 999999999
        this.disabled2 = true
      } else {
        this.disabled2 = false
      }
      /* if (!this.limitNum){
        this.form.limitNum =0;
      } */
    },
    getIsLimit(val) {
      if (val != null) {
        if (val === 1) {
          return '有'
        }
        if (val === 2) {
          return '无'
        }
      }
      return ''
    },
    handleNodeClick(data) {
      // 使 input 失去焦点，并隐藏下拉框
      this.$refs.selectTree.blur()
    },
    // 监听文本域
    timeEffectInput() {
      const length = this.form.remark.length // 先拿到当前输入时文本域文字长度
      if (length >= 200) {
        // 当长度超过200
        // 获取文本域计数统计设置字体为红色
        this.$el.querySelector('.el-input__count').style =
          'color:red !important'
        // 防止后续输入溢出截取0-200的字符
        this.form.remark = this.form.remark.substr(0, 200)
      } else {
        // 不超过则设置为原字体颜色
        this.$el.querySelector('.el-input__count').style =
          'color:#909399 !important'
      }
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - this.headerHeight - 290
    },

    // 获取数据
    getList() {
      var that = this
      that.loading = true
      const _url = this.status == 0 ? '/coupon/list' : '/couponTask/list'
      that.$http.post(_url, that.queryInfo).then(function (response) {
        if (response.data.code == 200) {
          that.loading = false
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
        } else {
          that.loading = false
          that.$message.error(response.data.message)
        }
      })
    },
    // 商品分级接口
    getProductCategory() {
      var that = this
      that.$http
        .post('/productCategory/queryList', {level: 2})
        .then(function (response) {
          if (response.data.code == 200) {
            that.productCategoryList = response.data.data
          }
        })
    },
    // 商品接口
    getProductList() {
      var that = this
      that.$http.post('/product/queryList', {}).then(function (response) {
        if (response.data.code == 200) {
          that.productList = response.data.data
        }
      })
    },
    // 优惠劵接口
    getCouponList() {
      var that = this
      that.$http.post('/coupon/queryList', {}).then(function (response) {
        if (response.data.code == 200) {
          that.rows = response.data.data
          that.couponList = response.data.data
        }
      })
    },
    // 用户接口
    getUserList() {
      var that = this
      that.$http.post('/member/queryList', {}).then(function (response) {
        if (response.data.code == 200) {
          that.memberList = response.data.data
          for (let i = 0; i < that.memberList.length; i++) {
            if (that.memberList[i].phone != null && that.memberList[i].phone != '') {
              that.phoneList.push(that.memberList[i].phone)
            }
          }
        }
      })
    },
    reset() {
      this.queryInfo = {
        pageSize: 100,
        currPage: 1,
        condition: {createTimeArr: []}
      }
      this.form = {}
      this.limitNum = false
      this.num = false
      this.daterange = []
      this.giveCouponForm.couponCodes = []
      this.giveCouponForm.phones = []
      this.giveCouponForm.count = null
      this.dataStatisticsQuery = {}
      this.getList()
    },
    resetThree() {
      this.queryInfo = {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {createTimeArr: []}
      }
      this.getGiveCouponRecords()
      this.getList()
    },
    // 保存
    handleSave() {
      console.log(4879453)

      this.saveFlag = 0
      if (this.form.limitType === 3) {
        var date = new Date()
        this.form.limitStartTime == date
        date.setFullYear(date.getFullYear() + 999)
        this.form.limitEndTime = date
      }
      if (this.daterange != null && this.daterange.length != 0) {
        this.form.limitStartTime = this.daterange[0]
        this.form.limitEndTime = this.daterange[1]
      }
      var that = this
      if (this.form.userType == 2) {
        if (this.form.userCodes.length == 0) {
          this.$notify.info({
            title: '提示',
            message: '请选择用户',
            showClose: true
          })
          return
        }
      }

      if (this.form.useArea == 3) {
        if (this.form.productCodes.length == 0) {
          this.$notify.info({
            title: '提示',
            message: '请选择商品',
            showClose: true
          })
          return
        }
      }

      if (this.form.useArea == 2) {
        if (this.form.categoryCodes.length == 0) {
          this.$notify.info({
            title: '提示',
            message: '请选择商品组',
            showClose: true
          })
          return
        }
      }
      that.$http
        .post('/coupon/save', that.form)
        .then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '保存成功',
              showClose: true
            })
            that.showDialog = false
            // that.getList();
            that.reset()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
          // this.saveFlag === 1;
        })
        .catch(error => {
          that.$notify.error({
            title: '提示',
            message: error,
            showClose: true
          })
          // this.saveFlag === 1;
        })
      // this.saveFlag === 1;
    },
    handlesiftSave() {
      var that = this
      if (![-1, 0, 1].includes(this.form.taskType)) {
        return this.$message.warning('请选择周期类型！')
      }
      this.saveFlag = 0
      const _indexOne = this.couponList.filter(item => item.couponCode == that.form.couponCode)
      let _form = {
        ...that.form,
        day: that.form.day.join(','),
        couponName: _indexOne.couponName,
        couponType: _indexOne.couponType,
        creator: JSON.parse(localStorage.getItem('userInfo')).userInfo.loginName
      }
      if (this.siftdaterange != null && this.siftdaterange.length != 0) {
        _form.startTime = this.siftdaterange?.[0]
        _form.endTime = this.siftdaterange?.[1]
      }
      console.log('1111', _form)
      that.$http
        .post('/couponTask/add', _form)
        .then(response => {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '新增成功',
              showClose: true
            })
            that.siftDialogVisible = false
            that.reset()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
          this.saveFlag === 1
        })
        .catch(error => {
          that.$notify.error({
            title: '提示',
            message: error,
            showClose: true
          })
          this.saveFlag === 1
        })
      this.saveFlag === 1
    },
    // 修改
    edit(row) {
      this.saveFlag = 1
      this.showDialog = true
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
      console.log('row====', row)
      if (this.form.limitType === 1) {
        this.daterange = [this.form.limitStartTime, this.form.limitEndTime]
      }
    },
    // 精选券详情
    diftdetail(row) {
      this.saveFlag = 1
      this.siftDialogVisible = true
      this.labelType = 'view'
      this.form = JSON.parse(JSON.stringify(row))
      if (this.form.taskType == 0) {
        this.checkAll = checkedCount == daylist1.length
        this.siftisIndeterminate = checkedCount > 0 && checkedCount < daylist1.length
      } else {
        this.checkAll = checkedCount == daylist2.length
        this.siftisIndeterminate = checkedCount > 0 && checkedCount < daylist2.length
      }
      this.form.day = this.form.day.split(',') || []
      this.siftdaterange = [this.form.startTime, this.form.endTime]
    },
    async getQueryTaskFitList() {
      let params = {
        limitStartTime: this.siftdaterange[0],
        limitEndTime: this.siftdaterange[1]
      }
      let res = await this.$http.post('/coupon/queryTaskFitList', params)
      if (res.data.code == 200) {
        this.couponList2 = res.data.data
      }
    },
    clearday() {
      this.form.day = []
      // this.siftdaterange = []
      this.siftisIndeterminate = false
      this.checkAll = false
    },
    handleCheckAllChange(val) {
      console.log('p--0', val, daylist1.length, daylist2.length)
      if (this.form.taskType == 0) {
        this.form.day = val ? daylist1 : []
      } else {
        this.form.day = val ? daylist2 : []
      }
      this.siftisIndeterminate = false
    },
    handleDayChange(value) {
      if (!value) return
      // console.log('p--1',value)
      let checkedCount = value?.length
      // console.log('p--2',checkedCount,daylist1.length,daylist2.length)
      if (this.form.taskType == 0) {
        this.checkAll = checkedCount == daylist1.length
        this.siftisIndeterminate = checkedCount > 0 && checkedCount < daylist1.length
      } else {
        this.checkAll = checkedCount == daylist2.length
        this.siftisIndeterminate = checkedCount > 0 && checkedCount < daylist2.length
      }
    },
    scannerChange(val) {
      this.form.fullAmountRule = 0
    },
    // 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/coupon/delete', {id: id}).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },

    // 新增按钮
    newBtn() {
      this.saveFlag = 1
      this.labelType = 'add'
      this.form = {
        limitNum: 0,
        num: 0,
        isShare: 2,
        activityShare: 2,
        couponCode: '',
        fullAmountRule: 0,
        day: []
      }
      this.showDialog = true
    },
    // 新增精选
    newsiftBtn() {
      this.saveFlag = 1
      this.labelType = 'add'
      this.getCouponList()
      this.siftDialogVisible = true
      this.form = {
        couponCode: '',
        fullAmountRule: 0,
        day: []
      }
      this.checkAll = false
      this.siftisIndeterminate = false
    },
    // 修改页数大小
    handleSizeChange(val) {
      this.saveFlag = 1
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange(val) {
      this.queryInfo.currPage = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.c-type {
  width: 100%;
}

.grid-content {
  align-items: center;
  display: flex;
  border-radius: 4px;
  min-height: 36px;
}

.bg-purple-dark {
  background: rgb(241, 241, 241);
}

.col-text {
  width: 50%;
}

.title-text {
  margin-left: 3%;
}

:deep .el-checkbox__inner::after {
  transform: translate(-50%, -50%) scale(1) !important;
  width: 4px;
  height: 4px;
  border-radius: 50% !important;
  background-color: var(--el-color-white);
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transition: transform 0.15s ease-in;
}

.el-checkbox__input {
  margin-right: 10%;
}

.top {
  margin-top: 3%;
}

.active-input {
  width: 50%;
}

.el-form-item__label {
  width: 121px;
}

.active-input-give {
  width: 80%;
}

.navActive {
  font-weight: bold;
  font-size: 30rpx;
  color: rgb(120 168 253);
  position: relative;
}

.navActive::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7rpx;
  background: rgb(120 168 253);
  border-radius: 0rpx 0rpx 0rpx 0rpx;
}

.nav {
  height: 50px;
  line-height: 50px;
  background: rgb(223 240 249);
}

.select-date {
  width: 100%;
}

/deep/ .a  .el-form-item {
  height: 30px;
}
//::v-deep .el-input__inner {
//  height: auto !important; /* 让高度自动调整 */
//  line-height: normal !important; /* 设置行高为正常 */
//  padding: 10px !important; /* 可选：根据需要调整内边距 */
//  //border: none !important; /* 可选：根据需要去掉边框 */
//}

</style>
